export enum Provider {
  AWS = 'AWS',
  GCP = 'GCP',
  Azure = 'Azure',
}

export enum AWSRegion {
  USWest2 = 'us-west-2',
  EUCentral1 = 'eu-central-1',
}

export enum GCPRegion {
  USCentral1 = 'us-central1',
}

export type Region = AWSRegion | GCPRegion

export interface ProviderInfo {
  provider: Provider
  title: string
  isAvailable: boolean
}

export interface RegionInfo {
  provider: Provider
  region: Region
  title: string
  isAvailable: boolean
  priority: number
}

export interface ProviderRegionState {
  allProviderRegions: ProviderRegion
  providerInfo: ProviderInfo
  regionInfo: RegionInfo
}

export interface Regions {
  [provider: string]: RegionInfo[]
}

export interface ProviderRegion {
  providerInfo: ProviderInfo[]
  regionInfo: Regions
}
